/**
 * Extracted from `pages/properties.tsx` (IMM-910.7) with one behavioural
 * change: below a minute, this formats the exact second delta instead of
 * collapsing to "now" — the fleet rail shows sub-minute ages on a 10s poll,
 * where `properties.tsx`'s callers never needed finer than a day.
 */
export function relativeTimeFromNow(iso: string, locale: string): string {
  const past = new Date(iso).getTime();
  const now = Date.now();
  const diffSeconds = Math.round((past - now) / 1000);
  const rtf = new Intl.RelativeTimeFormat(locale, { numeric: 'auto' });
  const absMin = Math.abs(diffSeconds) / 60;
  const absHr = absMin / 60;
  const absDay = absHr / 24;

  if (absMin < 1) return rtf.format(diffSeconds, 'second');

  if (absMin < 60) return rtf.format(Math.round(diffSeconds / 60), 'minute');

  if (absHr < 24) return rtf.format(Math.round(diffSeconds / 3600), 'hour');

  if (absDay < 30) return rtf.format(Math.round(diffSeconds / 86_400), 'day');

  return rtf.format(Math.round(diffSeconds / (86_400 * 30)), 'month');
}
